import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import DepartmentTopbar from "../SuperAdmin/components/DepartmentTopbar";
import DepartmentSidebar from "../SuperAdmin/components/DepertmentSidebar";

function EditHfaBeneficiary() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    Beneficiary_code: "",
    Beneficiary_name: "",
    Beneficiary_fathername: "",
    ward_no: "",
  });

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchBeneficiaryData = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/beneficiary-get.php?id=${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.data.success) {
          setFormData(response.data.data);
        } else {
          toast.error(
            response.data.message || "Failed to fetch beneficiary data."
          );
        }
      } catch (error) {
        toast.error("An error occurred while fetching data.");
      } finally {
        setLoading(false);
      }
    };
    fetchBeneficiaryData();
  }, [id, API_URL, token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/beneficiary-update.php`,
        { ...formData, id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Beneficiary updated successfully!");
        navigate("/departmentDashboard/hfa-beneficiary-list");
      } else {
        toast.error(response.data.message || "Failed to update beneficiary.");
      }
    } catch (error) {
      toast.error("An error occurred while updating the beneficiary.");
    }
  };

  const wardOptions = Array.from({ length: 25 }, (_, i) => i + 1);

  if (loading) {
    return (
      <div className="p-5 text-center">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <>
      <DepartmentTopbar />
      <div className="d-flex" style={{ minHeight: "calc(100vh - 56px)" }}>
        <DepartmentSidebar />
        <Container fluid className="p-4 bg-light">
          <h2 className="mb-4">Edit HFA Beneficiary</h2>
          <Row>
            <Col>
              <Card className="shadow-sm">
                <Card.Header
                  as="h5"
                  style={{
                    backgroundColor: "#e3f2fd",
                    borderBottom: "2px solid #1976d2",
                  }}
                >
                  <span style={{ color: "#1976d2" }}>
                    Update Beneficiary Details
                  </span>
                </Card.Header>
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6" controlId="Beneficiary_code">
                        <Form.Label>Beneficiary Code</Form.Label>
                        <Form.Control
                          type="text"
                          name="Beneficiary_code"
                          value={formData.Beneficiary_code}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                      <Form.Group as={Col} md="6" controlId="ward_no">
                        <Form.Label>Ward No</Form.Label>
                        <Form.Select
                          name="ward_no"
                          value={formData.ward_no}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Ward...</option>
                          {wardOptions.map((ward) => (
                            <option key={ward} value={ward}>
                              {ward}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6" controlId="Beneficiary_name">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="Beneficiary_name"
                          value={formData.Beneficiary_name}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="Beneficiary_fathername"
                      >
                        <Form.Label>Father's Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="Beneficiary_fathername"
                          value={formData.Beneficiary_fathername}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Row>
                    <Button variant="primary" type="submit" className="mt-2">
                      Update Beneficiary
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default EditHfaBeneficiary;
